/**
 * Defines the chart choices shared by the Charts page and forecast widgets.
 * Each choice names its forecast source and how to plot its values.
 * Keep this order stable: saved widgets select their initial chart by position.
 */
export const forecastChartConfig = [
  {
    id: 'detailedForecast',
    optionLabel: '5-Day Detailed Forecast',
    sourceKey: 'detailedForecast',
    chartType: 'bar',
  },
  {
    id: 'hourlyForecast',
    optionLabel: '7-Day Hourly Forecast',
    sourceKey: 'hourlyForecast',
    chartType: 'bar',
  },
  {
    id: 'day15Forecast',
    optionLabel: '15-Day Forecast',
    sourceKey: 'day15Forecast',
    chartType: 'bar',
  },
  {
    id: 'precipitationProbability',
    optionLabel: 'Chance of Precipitation',
    sourceKey: 'day15Forecast',
    chartType: 'bar',
    chartTitle: 'Chance of Precip. (%)',
    datasets: [
      {
        datasetLabel: 'Chance of Precip.',
        getValue: (forecast) => forecast.precip_prob,
        color: '#98ff18',
      },
    ],
  },
  {
    id: 'comfort',
    optionLabel: 'Comfort Level',
    sourceKey: 'day15Forecast',
    chartType: 'line',
    chartTitle: 'Comfort Temperature (°F)',
    datasets: [
      {
        datasetLabel: 'Comfort Level',
        getValue: (forecast) => forecast.comfort,
        color: '#800080',
      },
    ],
  },
  {
    id: 'dewPoint',
    optionLabel: 'Dew Point',
    sourceKey: 'day15Forecast',
    chartType: 'line',
    chartTitle: 'Dew Point (°F)',
    datasets: [
      {
        datasetLabel: 'Dew Point',
        getValue: (forecast) => forecast.dew_point,
        color: '#07fd08',
      },
    ],
  },
  {
    id: 'humidity',
    optionLabel: 'Humidity',
    sourceKey: 'day15Forecast',
    chartType: 'bar',
    chartTitle: 'Relative Humidity (%)',
    datasets: [
      {
        datasetLabel: 'Humidity',
        getValue: (forecast) => forecast.humidity,
        color: '#07fd08',
      },
    ],
  },
  {
    id: 'pressure',
    optionLabel: 'Pressure',
    sourceKey: 'day15Forecast',
    chartType: 'line',
    chartTitle: 'Pressure (")',
    datasets: [
      {
        datasetLabel: 'Pressure',
        getValue: (forecast) => forecast.baro_pressure,
        color: '#000000',
      },
    ],
  },
  {
    id: 'precipitation',
    optionLabel: 'Precipitation',
    sourceKey: 'day15Forecast',
    chartType: 'bar',
    chartTitle: 'Rainfall (in.)',
    datasets: [
      {
        datasetLabel: 'Precipitation',
        getValue: (forecast) => forecast.rainfall,
        color: '#0304e9',
      },
    ],
  },
  {
    id: 'temperature',
    optionLabel: 'Temperature',
    sourceKey: 'day15Forecast',
    chartType: 'line',
    chartTitle: 'Temperature (°F)',
    datasets: [
      {
        datasetLabel: 'High',
        getValue: (forecast) => forecast.high_temp,
        color: 'red',
      },
      {
        datasetLabel: 'Average',
        getValue: (forecast) =>
          (parseFloat(forecast.high_temp) + parseFloat(forecast.low_temp)) / 2,
        color: 'yellow',
      },
      {
        datasetLabel: 'Low',
        getValue: (forecast) => forecast.low_temp,
        color: 'blue',
      },
    ],
  },
  {
    id: 'windSpeed',
    optionLabel: 'Wind Speed',
    sourceKey: 'day15Forecast',
    chartType: 'line',
    chartTitle: 'Wind Speed (MPH)',
    datasets: [
      {
        datasetLabel: 'Wind Speed',
        getValue: (forecast) => forecast.wind_speed,
        color: '#2129d6',
        backgroundColor: '#2129d680',
        fill: true,
      },
    ],
  },
];
